import {IContestTimes} from 'modules/reducers/contest_times';
import {createAction} from 'redux-act';

export const fetchContestTimes = createAction('fetchContestTimes');
export const fetchContestTimesFailed = createAction('fetchContestTimesFailed');
export const fetchContestTimesSuccess = createAction<IContestTimes>('fetchContestTimesSuccess');